import * as z from 'zod';
import { CURRENCY } from 'src/types';

export type ReferenceRateFormSchemaValues = z.infer<typeof referenceRateFormSchema>;
export const referenceRateFormSchema = z.object({
    name: z.string().nonempty().max(256),
    code: z.string().nonempty().max(64),
    currency: z.enum(CURRENCY),
    description: z.string().max(1024).optional().nullable(),
    is_active: z.boolean().optional().nullable(),
});

export type PatchReferenceRateFormSchemaValues = z.infer<typeof patchReferenceRateFormSchema>;
export const patchReferenceRateFormSchema = referenceRateFormSchema.partial();
